import type { ReactElement } from 'react';

import { Icon } from '../icons/icon.component';
import { Typography } from '../typography';
import { createPadding } from '../ui-utils';

import type { ICardHeaderProps } from './card.interface';
export const CardHeader = ({
  title,
  size = 'body1',
  weight = 'normal',
  action,
  border = false,
  pb = 8,
  pt = 8,
  pl = 8,
  pr = 8,
  sticky,
  className,
  icon
}: ICardHeaderProps): ReactElement => {
  function createStickyPosition(): string {
    if (sticky) {
      return `co-sticky co-${sticky.position}-${sticky.distance}px`;
    }
    return 'co-relative';
  }
  return (
    <div
      className={`
            co-border-gray-xlight
            co-border-b-${border ? 1 : 0}
            co-flex
            ${createStickyPosition()}
            co-top-0px
            co-gap-8px
            ${createPadding({ pt, pb, pl, pr })}
            ${className}
            `}
    >
      <div
        className={`
                co-flex-1
                co-flex
                co-items-center
            `}
      >
        {typeof title === 'string' ? (
          <div className="co-flex co-items-center co-gap-3">
            {icon && <Icon icon={icon} color="primary" />}
            <Typography size={size} weight={weight}>
              {title}
            </Typography>
          </div>
        ) : (
          title
        )}
      </div>
      {action && <div className="co-flex co-items-center">{action}</div>}
    </div>
  );
};
